module platform {
  export class NotificationService {
    static $inject = ["$injector"];
    private _vscNotificationService: NotificationService;

    constructor(private $injector: any) {}

    get vscNotificationService(): NotificationService {
      if (!this._vscNotificationService) {
        this._vscNotificationService = this.$injector.get(
          "vscNotificationService"
        );
      }
      return this._vscNotificationService;
    }

    notify(options: any): void {
      return this.vscNotificationService.notify(options);
    }

    notifyError(
      title?: string,
      message?: string,
      stack?: string,
      unhandledError?: boolean
    ): void {
      return this.vscNotificationService.notifyError(
        title,
        message,
        stack,
        unhandledError
      );
    }

    notifyTaskError(taskInfo: any): void {
      return this.vscNotificationService.notifyTaskError(taskInfo);
    }
  }

  /**
   * @ngdoc service
   * @name com.vmware.platform.ui.notificationService
   * @module com.vmware.platform.ui
   *
   * @description
   *    Service for displaying notifications.
   *
   */
  angular
    .module("com.vmware.platform.ui")
    .service("notificationService", NotificationService);
}
